import { saveCommissions } from "../Infrastructure/Commissions.store";
import { getCommissionsLogic } from "./Commissions.logic";

export async function getCommissions(params) {
  const commissions = await getCommissionsLogic(params);
  saveCommissions(commissions);
}
